var _path, _path2, _path3, _path4, _rect, _g, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgBfidDocumentBlur(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 105,
    height: 67,
    viewBox: "0 0 105 67",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M103.656 47L103.656 55.6555C103.656 61.1783 99.1791 65.6555 93.6562 65.6555L85.0008 65.6555",
    stroke: "#E4E4E4",
    strokeWidth: 0.932773
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M85 1L93.6555 1C99.1783 1 103.655 5.47715 103.655 11V19.6555",
    stroke: "#E4E4E4",
    strokeWidth: 0.932773
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M1 19.6555L1 11C0.999999 5.47715 5.47715 0.999994 11 0.999994L19.6555 0.999993",
    stroke: "#E4E4E4",
    strokeWidth: 0.932773
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M19.6562 65.6555L11.0008 65.6555C5.47794 65.6555 1.00079 61.1783 1.00079 55.6555L1.00079 47",
    stroke: "#E4E4E4",
    strokeWidth: 0.932773
  })), /*#__PURE__*/React.createElement("mask", {
    id: "mask0_212_3165",
    style: {
      maskType: "alpha"
    },
    maskUnits: "userSpaceOnUse",
    x: 0,
    y: 0,
    width: 91,
    height: 55
  }, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    width: 91,
    height: 55,
    rx: 7.46218,
    fill: "url(#paint0_linear_212_3165)",
    fillOpacity: 0.6
  }))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask0_212_3165)",
    transform: "translate(7, 6)"
  }, /*#__PURE__*/React.createElement("g", {
    filter: "url(#filter0_f_212_3165)"
  }, /*#__PURE__*/React.createElement("g", {
    filter: "url(#filter1_bf_212_3165)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M6.56056 17.9509C7.07429 10.5874 13.5844 5.11285 20.9269 5.86981L54.1523 9.29511C55.3779 9.42147 56.6153 9.37373 57.8275 9.15332L68.1051 7.28466C76.1212 5.8272 83.5 11.9854 83.5 20.1328V32.9283C83.5 39.5266 78.5778 45.0883 72.0284 45.8903L59 47.4856H18.5016C10.9316 47.4856 4.94763 41.0696 5.47449 33.5179L6.56056 17.9509Z",
    fill: "url(#paint1_linear_212_3165)",
    fillOpacity: 0.9
  })), /*#__PURE__*/React.createElement("g", {
    filter: "url(#filter2_b_212_3165)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: -2,
    y: -1,
    width: 95,
    height: 57,
    rx: 8,
    fill: "url(#paint2_linear_212_3165)",
    fillOpacity: 0.2
  })), /*#__PURE__*/React.createElement("path", {
    d: "M44.8789 17.5078H75.2194",
    stroke: "white",
    strokeWidth: 2.33193,
    strokeLinecap: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M44.8789 26.0378H75.2194",
    stroke: "white",
    strokeWidth: 2.33193,
    strokeLinecap: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M44.8789 34.0939H64.1427",
    stroke: "white",
    strokeWidth: 2.33193,
    strokeLinecap: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M23.6165 25.0954C23.4881 25.0828 23.334 25.0828 23.1927 25.0954C20.1362 24.9943 17.709 22.5301 17.709 19.4972C17.709 16.4012 20.2518 13.8864 23.4111 13.8864C26.5575 13.8864 29.1131 16.4012 29.1131 19.4972C29.1003 22.5301 26.6731 24.9943 23.6165 25.0954Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M17.1952 29.7585C14.0873 31.8057 14.0873 35.1419 17.1952 37.1765C20.7269 39.5017 26.5189 39.5017 30.0505 37.1765C33.1584 35.1293 33.1584 31.7931 30.0505 29.7585C26.5317 27.4459 20.7397 27.4459 17.1952 29.7585Z",
    fill: "white"
  })))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("filter", {
    id: "filter0_f_212_3165",
    x: -6,
    y: -5,
    width: 103,
    height: 65,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "BackgroundImageFix",
    result: "shape"
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 2,
    result: "effect1_foregroundBlur_212_3165"
  })), /*#__PURE__*/React.createElement("filter", {
    id: "filter1_bf_212_3165",
    x: -3.88559,
    y: -3.5279,
    width: 96.7133,
    height: 60.3412,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    in: "BackgroundImageFix",
    stdDeviation: 4.66387
  }), /*#__PURE__*/React.createElement("feComposite", {
    in2: "SourceAlpha",
    operator: "in",
    result: "effect1_backgroundBlur_212_3165"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "effect1_backgroundBlur_212_3165",
    result: "shape"
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 1.86555,
    result: "effect2_foregroundBlur_212_3165"
  })), /*#__PURE__*/React.createElement("filter", {
    id: "filter2_b_212_3165",
    x: -20.6555,
    y: -19.6555,
    width: 132.311,
    height: 94.3109,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    in: "BackgroundImageFix",
    stdDeviation: 9.32773
  }), /*#__PURE__*/React.createElement("feComposite", {
    in2: "SourceAlpha",
    operator: "in",
    result: "effect1_backgroundBlur_212_3165"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "effect1_backgroundBlur_212_3165",
    result: "shape"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint0_linear_212_3165",
    x1: 45.5,
    y1: 0,
    x2: 45.5,
    y2: 55,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#83109C"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#330B96"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint1_linear_212_3165",
    x1: 44.9654,
    y1: 7.08221,
    x2: 44.9654,
    y2: 45.9411,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#83109C"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#330B96"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint2_linear_212_3165",
    x1: 45.5,
    y1: -1,
    x2: 45.5,
    y2: 56,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#83109C"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#330B96"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgBfidDocumentBlur);
export default __webpack_public_path__ + "static/media/bfid-document-blur.b59ac7323efd6c95115bd5f8903fc8d1.svg";
export { ForwardRef as ReactComponent };